import { commonTransform } from "../handleTransformation";
import { tags } from "../constants";
import {
  GET_USERS_FOR_FILTER_URL,
  GET_JOURNEYS_FOR_FILTER_URL,
  GET_COMPANIES_FOR_FILTER_URL,
  GET_COMPANY_ADMINS_FOR_FILTER_URL,
  GET_ROLES_FOR_FILTER_URL,
  GET_COMPANY_CUSTOM_ATTRIBUTES_FOR_FILTER_URL,
  GET_HIRING_MANAGER_PORTAL_FILTERS_URL
} from "services/url.service";

export const filterQueries = {
  getUsersForFilter: {
    getUrl: ({ companyId, role }) => {
      return GET_USERS_FOR_FILTER_URL(companyId, role);
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.FILTERS],
  },
  getJourneysForFilter: {
    getUrl: ({ companyId }) => {
      return GET_JOURNEYS_FOR_FILTER_URL(companyId);
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.FILTERS],
  },
  getCompaniesForFilter: {
    getUrl: () => {
      return GET_COMPANIES_FOR_FILTER_URL();
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.FILTERS],
  },
  getCompanyAdminsForFilter: {
    getUrl: () => {
      return GET_COMPANY_ADMINS_FOR_FILTER_URL();
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.FILTERS],
  },
  getRolesForFilter: {
    getUrl: () => {
      return GET_ROLES_FOR_FILTER_URL();
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.FILTERS],
  },
  getCompanyCustomAttributesForFilter: {
    getUrl: ({ companyId }) => {
      return GET_COMPANY_CUSTOM_ATTRIBUTES_FOR_FILTER_URL(companyId);
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.FILTERS],
  },
  getHiringManagerPortalFilters: {
    getUrl: ({ companyId }) => GET_HIRING_MANAGER_PORTAL_FILTERS_URL(companyId),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.HIRING_MANAGER_PORTAL_FILTERS],
  }
};
